import createPermission from 'permissions/createPermission'

export const markAsViewed = createPermission('events.view')
export const videoOnDemand = createPermission('events.videoOnDemand')
export const videoAttached = createPermission('events.attachedVideo')